export default "__VITE_ASSET__D_P7aPVN__"